export const SET_TEMPLATE_TO_CREATE = 'SET_TEMPLATE_TO_CREATE';

export const setSelectedTemplate = (templateName, clickOrDrag) => {
	const newScene = { templateName, clickOrDrag }
	return {
		type: SET_TEMPLATE_TO_CREATE,
		payload: newScene,
	};
};
